import React, { useEffect, useState } from 'react';
import { useEmailValue } from '@/hooks/tab';
import { useClientEmail } from '@/hooks/client';
import { useCurrentEmailItem } from '@/hooks/reference';
import { ClientTab } from '@/types/common';
import { ClientView } from '@/components/organisms/sidebar/Common';

const View: React.FC = () => {
  const [clientTab, setClientTab] = useState(ClientTab.BOUGHT);
  const [tabs, setTabs] = useState([clientTab]);
  const [inputValue] = useEmailValue();
  const [currentItem, setCurrentItem] = useCurrentEmailItem();
  const data = useClientEmail(inputValue);

  // Check if can remove this
  useEffect(() => {
    if (!tabs.includes(clientTab)) {
      setTabs([...tabs, clientTab]);
    }
  }, [clientTab]);

  return (
    <ClientView
      isEmailTab={true}
      isPhoneTab={false}
      inputValue={inputValue}
      clientTab={clientTab}
      clientTabs={tabs}
      setClientTab={setClientTab}
      setCurrentItem={setCurrentItem}
      currentItem={currentItem}
      data={data}
    />
  );
};

export default View;
